module.exports = __webpack_public_path__ + "img/pc4.94b2a26c.png";